/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useQuery } from '@apollo/client';
import { reactSelectInlineError } from '@nile/banyan/src/Utils/style';
import {
  COMMON_CONSTANTS,
  getLokaliseKeyByProduct,
  getTranslatedText,
  NoDataCard,
  SelectionSheet,
  useProduct,
  useSiteListForDropdown
} from '@nile/components';
import { AccountClient, GET_CLIENTS } from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import {
  Banner,
  Button,
  DisplayText,
  ResourceList,
  Sheet,
  RadioButton,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { sortBy } from 'lodash';
import ClientNameList from './ClientNameList';

function alphaSortClientList(list) {
  if (!list) {
    return [];
  }
  return sortBy(list, (obj) => obj.name.toLowerCase());
}

function TechnicianClient(props) {
  const { intl, accessAllClients, setAccessAllClients } = props;
  const [sheetActive, setSheetActive] = useState(false);
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const [allData, setAllData] = useState([]);
  const currentProduct = useProduct();

  const [selectedItems, setSelectedItems] = useState(() =>
    alphaSortClientList(props.clientList).map((el) => {
      return {
        ...el,
        id: el.accountId || el.id,
        name: el.name,
        label: el.name
      };
    })
  );
  const { loading, error, data: allClients } = useQuery(GET_CLIENTS, {
    client: AccountClient,
    skip: !isMSPProduct,
    variables: {
      listInfo: {
        sort: {
          attribute: 'name',
          order: 'ASC'
        }
      }
    },
    onCompleted: (res) => {
      if (res?.getClientList) {
        setAllData(res.getClientList?.clients || []);
      }
    }
  });
  const { getClientSites, data: sites } = useSiteListForDropdown();

  useEffect(() => {
    if (!isMSPProduct) {
      getClientSites();
    }
  }, []);

  useEffect(() => {
    if (sites) {
      setAllData(sites);
    }
  }, [sites]);
  const toggleSheetActive = useCallback(
    () => setSheetActive((sheetActive) => !sheetActive),
    []
  );

  const updateParent = (items) => {
    setSelectedItems(alphaSortClientList(items));
    props.updateClientList(items);
  };

  // const { clients } = allClients?.getClientList || [];

  const sections = useMemo(() => {
    if (accessAllClients) {
      return [
        {
          name: 'banner',
          status: 'info',
          header: getTranslatedText(
            intl,
            getLokaliseKeyByProduct(
              currentProduct,
              'techGroupAllSelectionBanner'
            )
          ),
          items: []
        }
      ];
    }

    return [
      {
        name: 'client',
        header: getTranslatedText(
          intl,
          'admin.Techniciangroup.client.allclients'
        ),
        items:
          allData?.map((el) => {
            return {
              ...el,
              id: el.accountId || el.id,
              name: el.name,
              label: el.name
            };
          }) || []
      }
    ];
  }, [intl, allData, accessAllClients]);

  const clientPreferenceOptions = ['clients', 'allClients'];
  function getLokaliseKeys(option) {
    if (option === 'clients') {
      return getLokaliseKeyByProduct(currentProduct, 'techGroupIndividual');
    }
    return getLokaliseKeyByProduct(currentProduct, 'techGroupAllClientSite');
  }

  const additionalSections = (
    <div className="fx actr g20 mt24 wrap">
      {clientPreferenceOptions.map((option) => {
        const isChecked = accessAllClients
          ? option === 'allClients'
          : option === 'clients';
        return (
          <div onClick={() => setAccessAllClients(option === 'allClients')}>
            <RadioButton
              id={option}
              label={
                <TextStyle weight={isChecked ? 'Bold' : 'Regular'}>
                  <FormattedMessage id={getLokaliseKeys(option)} />
                </TextStyle>
              }
              checked={isChecked}
            />
          </div>
        );
      })}
    </div>
  );

  if (loading) return <div>loading...</div>;

  return (
    <div className="fx col w100">
      <div className="fx">
        <div className="fx2 Technician-Group-Association f-20 mt-14 mb-14">
          <div className="fx actr plr-20">
            <DisplayText size="extraLarge" weight="SemiBold">
              <FormattedMessage
                id={getLokaliseKeyByProduct(
                  currentProduct,
                  'techGroupClientBoxHeading'
                )}
              />
            </DisplayText>
          </div>
        </div>
        <div className="fx2 fx actr jend">
          <Button
            onClick={toggleSheetActive}
            id="techClient"
            icon={<SVGIcon name="AssignToMeIcon" />}
          >
            <FormattedMessage id="common.edit" />
          </Button>
        </div>
        <Sheet open={sheetActive} onClose={toggleSheetActive}>
          <SelectionSheet
            sections={sections}
            actions={props.actions}
            meta={{
              heading: getTranslatedText(
                intl,
                getLokaliseKeyByProduct(
                  currentProduct,
                  'techGroupChooseClientSite'
                )
              ),
              selectedTitle: getTranslatedText(
                intl,
                getLokaliseKeyByProduct(
                  currentProduct,
                  'techGroupSelectedClientSite'
                )
              )
            }}
            noSearchBar={accessAllClients}
            selectedItems={selectedItems}
            toggleSheetActive={toggleSheetActive}
            updateParent={updateParent}
            sectionHandler={
              accessAllClients
                ? (section) => {
                    return (
                      <Banner
                        status={section?.status}
                        title={section?.header}
                      />
                    );
                  }
                : null
            }
            additionalSections={additionalSections}
          />
        </Sheet>
      </div>
      {accessAllClients && (
        <div className="fx actr g10 pl20 pt10">
          <SVGIcon name="ClientLogo" />
          <DisplayText element="h3" weight="SemiBold">
            <FormattedMessage
              id={getLokaliseKeyByProduct(
                currentProduct,
                'techGroupAvailableClientSite'
              )}
            />
          </DisplayText>
        </div>
      )}
      {!accessAllClients &&
        (selectedItems.length === 0 ? (
          <div className="full-width flex center jcenter mt-30">
            <NoDataCard
              imageURL={`url(${envConfig.imageRoot}svg/documents-empty-state.svg)`}
              text={
                <FormattedMessage
                  id={getLokaliseKeyByProduct(
                    currentProduct,
                    'techGroupClientsEmpty'
                  )}
                />
              }
              type="secondary"
            />
          </div>
        ) : (
          <div className="Technician-Group-List">
            <ResourceList
              items={selectedItems}
              renderItem={ClientNameList.bind(this, allData)}
            />
            {props.errors?.clients &&
              reactSelectInlineError(props.errors.clients[0])}
          </div>
        ))}
    </div>
  );
}
export default injectIntl(TechnicianClient);
